/**
 * Looks a key up with the caller's translate function, falling back to the
 * given English when the caller has no translation for it.
 *
 * i18next hands back the key itself for a missing translation, and tests often
 * pass an identity function, so "the key came back" is read as "no
 * translation" and today's English is shown rather than a raw key.
 *
 * @param t - The caller's translate function, e.g. i18next's `t`
 * @param key - The translation key to look up
 * @param fallback - The English shown when `t` has nothing for the key
 */
export const translateOrDefault = (
  t: ((key: string) => string) | undefined,
  key: string,
  fallback: string,
): string => {
  if (!t) return fallback;
  const translated = t(key);
  return translated && translated !== key ? translated : fallback;
};
